import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import AuthGuard from '../components/AuthGuard'
import { StudentDetailClient } from '../components/students/StudentDetailClient'

function StudentDetailError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load student.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/students/$id')({
  head: () => ({
    meta: [{ title: 'Student Detail | Unbreakable' }],
  }),
  errorComponent: StudentDetailError,
  component: StudentDetailPage,
})

function StudentDetailPage() {
  const { id } = Route.useParams()
  return (
    <AuthGuard>
      <StudentDetailClient studentId={id} />
    </AuthGuard>
  )
}
